export default ['$window', 'TransportService', function ($window, TransportService) {
    return {
        send: function send(xCenterType, serviceEndpoint, method, params) {
            return TransportService.send(xCenterType, serviceEndpoint, method, params).catch(function (error) {
                if (TransportService.isSessionExpiredReason(error)) {
                    // refresh the page to get to login page
                    /* Set reload to true. Some "autentication solutions" does not set proper
                     * caching headers.
                     */
                    $window.location.reload(true);
                }
                throw error;
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/jsonrpc/JsonRPCService.js
// module id = 1907
// module chunks = 0